import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../auth/components/AuthInit";
import DarkMode from "./DarkMode";
import Logo from "./Logo";
import "./sideBar.css";

// --- Configuration ---

const MENU_GROUPS = [
  { id: "dashboard", label: null },
  { id: "accountList", label: "accountList" },
  { id: "transaction", label: "transaction" },
  { id: "report", label: "report" },
  { id: "vip", label: "vip" },
  { id: "refund", label: "refundNPromotion" },
  { id: "platform", label: "platformSetting" },
  { id: "personal", label: "personal" },
];

// Helper to define items cleanly
// permission: string (key in permissions object) | null
// role: string (specific role required) | null
const createItem = (id, path, icon, labelId, group, bg, permission = null, role = null) => ({
  id,
  path,
  icon,
  labelId,
  group, // 'main', 'transaction', 'report', etc.
  bg, // Active background color
  permission,
  role,
});

const MENU_ITEMS = [
  // --- Dashboard Group ---
  createItem("dashboard", "/dashboard", "bi bi-house", "dashboard", "dashboard", "#f6f9ff"),

  // --- Account List Group ---
  createItem("searchByUsername", "/searchByUsername", "bi bi-search", "searchByUsername", "accountList", "#f6f9ff"),
  createItem("accountList", "/accountList", "bi bi-person-fill-add", "accountList", "accountList", "#f6f9ff"),
  createItem("messageBox", "/messageBox", "bi bi-chat-square-text", "messageBox", "accountList", "#f6f9ff"),
  // Note: projectCredit was commented out in original, keeping it out or strictly following role 'main' if uncommented.
  
  // --- Transaction Group ---
  createItem("topupRequest", "/transaction/topupRequest", "bi bi-credit-card-2-back", "topupRequest", "transaction", "rgba(0, 255, 0, 0.15)", "membertopupwithdraw"),
  createItem("topupHistory", "/transaction/topupHistory", "bi bi-postcard", "topupHistory", "transaction", "rgba(0, 255, 0, 0.15)", "membertopupwithdraw"),
  createItem("withdrawRequest", "/transaction/withdrawRequest", "bi bi-box-arrow-up", "withdrawRequest", "transaction", "rgba(255, 0, 0, 0.15)", "membertopupwithdraw"),
  createItem("withdrawHistory", "/transaction/withdrawHistory", "bi bi-postcard", "withdrawHistory", "transaction", "rgba(255, 0, 0, 0.15)", "membertopupwithdraw"),
  // paymentOnHold commented out
  createItem("paymentGateway", "/transaction/paymentGateway", "bi bi-globe", "paymentGateway", "transaction", "rgba(255,243, 128,0.15)"),
  createItem("telco", "/transaction/telco", "bi bi-phone", "telco", "transaction", "rgba(255,243, 128,0.15)"),

  // --- Report Group ---
  // companyWinLoss commented out
  // viewfcReportPermission items
  createItem("agentDownlineReport", "/agentReport/agentDownlineReport", "bi bi-clipboard2-pulse", "agentDownlineReport", "report", "rgba(123,63, 0,0.15)", "viewfcreport"),
  
  createItem("transactionReport", "/agentReport/transactionReport", "bi bi-file-earmark-text", "transactionReport", "report", "rgba(123,63, 0,0.15)"),
  createItem("gameSummaryReport", "/agentReport/gameSummaryReport", "bi bi-file-earmark-text", "memberSummary", "report", "rgba(123,63, 0,0.15)"),
  createItem("agentReport", "/agentReport", "bi bi-clipboard2-data", "gameSummary", "report", "rgba(123,63, 0,0.15)"),

  // --- VIP Group ---
  createItem("vipList", "/vipList", "bi bi-star-fill", "vipList", "vip", "rgba(160,32,240,0.15)"),
  createItem("vipGameCommission", "/vipGameCommission", "bi bi-list-stars", "vipGameCommission", "vip", "rgba(160,32,240,0.15)"),
  createItem("vipCommission", "/vipCommission", "bi bi-list-stars", "vipCommission", "vip", "rgba(160,32,240,0.15)"),
  createItem("vipVipCommission", "/vipVipCommission", "bi bi-list-stars", "vipVipCommission", "vip", "rgba(160,32,240,0.15)"),
  createItem("vipHistory", "/vipHistory", "bi bi-list-stars", "vipHistory", "vip", "rgba(160,32,240,0.15)"),
  createItem("vipVipHistory", "/vipVipHistory", "bi bi-list-stars", "vipVipHistory", "vip", "rgba(160,32,240,0.15)"),
  createItem("vipEvaluate", "/vipEvaluate", "bi bi-list-stars", "vipEvaluate", "vip", "rgba(160,32,240,0.15)"),

  // --- Refund Group ---
  createItem("memberRefund", "/memberRefund", "bi bi-person-fill-add", "memberRefund", "refund", "rgba(255,165, 0,0.15)", "bonuspromosetting"),
  createItem("memberRefundOld", "/memberRefund/memberRefundOld", "bi bi-person-fill-add", "memberRefundOld", "refund", "rgba(255,165, 0,0.15)", "bonuspromosetting"),
  createItem("memberRefundHistory", "/memberRefund/memberRefundHistory", "bi bi-person-fill-add", "memberRefundHistory", "refund", "rgba(255,165, 0,0.15)", "bonuspromosetting"),
  createItem("promotion", "/promotion", "bi bi-percent", "promotion", "refund", "rgba(255,165, 0,0.15)", "bonuspromosetting"),

  // --- Platform Setting Group ---
  createItem("uiWording", "/platformSetting/uiWording", "bi bi-list", "uiWording", "platform", "rgba(160,32,240,0.15)"),
  createItem("gameActiveList", "/platformSetting/gameActiveList", "bi bi-ban", "gameActiveList", "platform", "rgba(160,32,240,0.15)"),
  createItem("bankAccount", "/platformSetting/bankAccount", "bi bi-bank", "bankAccount", "platform", "rgba(160,32,240,0.15)"),
  createItem("contactList", "/platformSetting/contactList", "bi bi-person-lines-fill", "contactList", "platform", "rgba(160,32,240,0.15)"),
  createItem("paymentMethod", "/platformSetting/paymentMethod", "bi bi-coin", "paymentMethod", "platform", "rgba(160,32,240,0.15)"),
  createItem("companyGameList", "/platformSetting/companyGameList", "bi bi-controller", "companyGameList", "platform", "rgba(160,32,240,0.15)"),
  createItem("telegramList", "/platformSetting/telegramList", "bi bi-telegram", "telegramList", "platform", "rgba(160,32,240,0.15)"),

  // --- Personal Group ---
  createItem("cashierSetting", "/cashierSetting", "bi bi-person", "cashierSetting", "personal", "rgba(0, 255, 255,0.15)"),
  createItem("subAgentList", "/subAgentList", "bi bi-person", "subAgentList", "personal", "rgba(0, 255, 255,0.15)", null, "main"),
  createItem("changePassword", "/changePassword", "bi bi-pen", "changePassword", "personal", "rgba(0, 255, 255,0.15)"),
];

// Separate mapping for path -> activeItem if strictly needed for edge cases (e.g. sub-paths)
// Can mostly rely on MENU_ITEMS.find, but let's handle the specific overrides from original code.
// Original code had things like `path.includes("/home") -> "searchByUsername"`.
const PATH_OVERRIDES = {
  "/home": "searchByUsername",
  "/agentList": "accountList",
  "/memberList": "accountList",
  "/gameActiveList": "gameActiveList", // matches default
  "/lotteryPayout": "lotteryPayout", // Not in menu? keeping generic fallback
  "/agentDownlineReport": "agentDownlineReport",
  // Add others if they deviate from the simple item.path check
};


export default function SideBar() {
  const intl = useIntl();
  const { logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname;

  const [userRole, setUserRole] = useState("");
  const [permissions, setPermissions] = useState({});
  const [activeItem, setActiveItem] = useState("searchByUsername");
  const [theme, setTheme] = useState("light");
  const platform = localStorage.getItem("platform");
  const searchParams = new URLSearchParams(window.location.search);
  const isTelegram = searchParams.get("platform") === "telegram" || platform === "telegram";

  // --- Effects ---

  // 1. Load Permissions & Role & Theme
  useEffect(() => {
    const storedPermissions = JSON.parse(localStorage.getItem("permissions"));
    const storedRole = localStorage.getItem("role");
    
    // Check initial theme
    const bodyTheme = document.body.getAttribute('data-theme');
    if(bodyTheme) setTheme(bodyTheme);

    // Listen to theme changes
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.attributeName === "data-theme") {
                setTheme(document.body.getAttribute('data-theme'));
            }
        });
    });
    observer.observe(document.body, { attributes: true });

    if (storedPermissions) {
      const permMap = {};
      storedPermissions.forEach((p) => {
        permMap[p.permissioncode] = p.allow === "true";
      });
      setPermissions(permMap);
    }
    if (storedRole) {
      setUserRole(storedRole);
    }
    return () => observer.disconnect();
  }, []);

  // 2. Determine Active Item based on Path
  useEffect(() => {
    // Check overrides first
    for (const [key, value] of Object.entries(PATH_OVERRIDES)) {
      if (path.includes(key)) {
        setActiveItem(value);
        return;
      }
    }

    // Check menu items
    const found = MENU_ITEMS.find((item) => path.includes(item.id) || path.includes(item.path));
    if (found) {
      setActiveItem(found.id);
    } else if (path.includes("/paymentOnHold")) {
       setActiveItem("paymentOnHold");
    } else {
       // Fallback
       setActiveItem("searchByUsername");
    }
  }, [path]);


  // --- Handlers ---

  const handleItemClick = (item) => {
    setActiveItem(item);
    if (window.innerWidth <= 768) {
      document.body.classList.toggle("toggle-sidebar");
    }
  };

  const handleClose = () => {
    document.body.classList.toggle("toggle-sidebar");
  };

  const handleLogout = async () => {
    if (sessionStorage.getItem("platform") === "mobile") {
      console.log("press:logout");
      localStorage.clear();
      sessionStorage.clear();
    } else {
      await logout();
    }
  };

  // --- Render Helpers ---

  const renderMenuItem = (item) => {
    // Permission Check
    if (item.permission && !permissions[item.permission]) return null;
    
    // Role Check
    if (item.role && userRole !== item.role) return null;

    const isActive = activeItem === item.id;
    const isDark = theme === 'dark';
    
    let backgroundColor = item.bg;
    let textColor = "";

    // Fix for default lighter colors in dark mode for non-active items
    if (backgroundColor === "#f6f9ff") {
         backgroundColor = "rgba(0, 255, 255,0.15)";
    }

    if (isActive) {
        // Active Text: Dark Mode = White, Light Mode = Blue
        textColor = isDark ? "#ffffff" : "#4154f1";
        
        // Active Background: 
        // Dark Mode: Dark Cyan Tint (rgba(13, 202, 240, 0.4)) - Increased opacity slightly for visibility
        // Light Mode: Whiteish (#f6f9ff)
        backgroundColor = isDark ? "rgba(13, 202, 240, 0.4)" : "#f6f9ff";
    }

    return (
      <li
        key={item.id}
        className="nav-item"
        onClick={() => {
          handleItemClick(item.id);
          navigate(item.path);
        }}
      >
        <div
          className="nav-link"
          style={{
            color: textColor,
            background: backgroundColor,
          }}
        >
          <i className={item.icon}></i>
          <span>{intl.formatMessage({ id: item.labelId })}</span>
        </div>
      </li>
    );
  };

  return (
    <div className={"sidebar-container"}>
      <aside id="sidebar" className="sidebar">
        <ul className="sidebar-nav" id="sidebar-nav">
          <div
            className="d-flex"
            style={{ margin: "5px", justifyContent: "space-between" }}
          >
            <Logo openfrom={"home"} />
            <i className="bi bi-x" onClick={() => handleClose()} />
          </div>
          <hr />
          <div
            className="d-flex"
            style={{ margin: "5px", justifyContent: "space-between" }}
          >
            <i
              className="bi bi-x"
              style={{ visibility: "hidden" }}
              onClick={() => handleClose()}
            />
            <DarkMode />
          </div>

          {MENU_GROUPS.map((group) => {
            // Check for project-specific hiding
            // Find items belonging to this group
            const groupItems = MENU_ITEMS.filter((i) => i.group === group.id);
            
            if (groupItems.length === 0) return null;

            return (
              <div key={group.id}>
                {group.label && (
                   <li className="nav-item">
                      <span>{intl.formatMessage({ id: group.label })}</span>
                   </li>
                )}
                {groupItems.map(renderMenuItem)}
              </div>
            );
          })}

		  {/* Logout is always at bottom */}
          {!isTelegram && (
            <li className="nav-item">
              <div className="nav-logout" onClick={handleLogout}>
                <i className="bi bi-box-arrow-left"></i>
                <span>{intl.formatMessage({ id: "logout" })}</span>
              </div>
            </li>
          )}
        </ul>
      </aside>
      <div
        className="backdrop"
        onClick={() => {
          document.body.classList.toggle("toggle-sidebar");
        }}
      />
    </div>
  );
}
